"use client";

import React, { useState, useMemo } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";
import {
  ChevronDown,
  Search as SearchIcon,
  Wallet,
  Mail,
  Phone,
} from "lucide-react";
import addressImage from "../assets/images/settings/address_book.png";

const PAYMENT_IDS = [
  { value: "PayID", label: "PayID", Icon: Wallet },
  { value: "Email", label: "Email", Icon: Mail },
  { value: "Cellphone", label: "Cellphone", Icon: Phone },
];

const PaymentIdSelect = ({ selectedId, onSelect, list }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const current = PAYMENT_IDS.find((item) => item.value === selectedId);
  const triggerLabel = current ? current.label : "PayID";
  const TriggerIcon = current ? current.Icon : Wallet;

  const filteredPaymentIds = useMemo(() => {
    if (!list) {
      return PAYMENT_IDS.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (list) {
      return list.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }, [searchTerm, list]);

  return (
    <div className="w-full">
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger asChild>
          <div className="w-full border border-[#CECBD7] rounded-[16px] p-[24px] h-[88px] flex items-center justify-between cursor-pointer bg-white">
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#33125F]">
                {!list ? (
                  <TriggerIcon className="w-4 h-4 text-white" />
                ) : (
                  <img
                    src={addressImage}
                    alt={"addresses icon"}
                    width={56}
                    height={56}
                    quality={100}
                    className="object-cover"
                  />
                )}
              </span>
              <span className="text-[16px] text-[#423E51] font-semibold">
                {triggerLabel}
              </span>
            </span>
            <ChevronDown size={12} className="text-gray-400" />
          </div>
        </DialogTrigger>

        <DialogContent className="max-w-md rounded-lg">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">
              Select a payment ID
            </DialogTitle>
          </DialogHeader>
          <div className="mt-4">
            <div className="relative">
              <Input
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="mb-4 w-full rounded-full"
              />
              <SearchIcon
                size={16}
                className="absolute right-4 top-2.5 text-gray-400"
              />
            </div>

            <ul className="space-y-2 max-h-[300px] overflow-y-auto">
              {filteredPaymentIds.map((item) => (
                <li
                  key={item.value}
                  className="flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-md cursor-pointer hover:border-rose-500/50 hover:border-s"
                  onClick={() => {
                    onSelect(item.value);
                    setIsOpen(false);
                  }}
                >
                  <div className="flex items-center gap-2">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-purple-500 to-rose-500">
                      <item.Icon className="w-6 h-6 text-white" />
                    </span>
                    <p className="text-sm font-medium">{item.label}</p>
                  </div>
                </li>
              ))}
              {filteredPaymentIds.length === 0 && (
                <li className="text-center text-sm text-gray-500">
                  No payment IDs found
                </li>
              )}
            </ul>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PaymentIdSelect;
